import { Price } from './price.model';
import { IProduct, IProductDeletable, IProductFavoratable, IProductNavigatable } from '../contract/product.contract';
import { Router } from '@angular/router';


export class CatalogueItem implements IProduct, IProductNavigatable, IProductDeletable, IProductFavoratable {
    public detailPage = ['sampling-supplies/', this.id];
    public discriminator;
    public iProductDeletableDiscriminator;
    public iProductFavoratableDiscriminator;

    // TODO: For now setting category as a string, need to update it to type - Category
    constructor(public id: number,
        public name: string,
        public code: string,
        public description: string,
        public quantity: number,
        public price: Price,
        public categories: string[],
        public categoryId: number,
        public resourceType) {
        this.iProductDeletableDiscriminator = 'IProductDeletable';
        this.iProductFavoratableDiscriminator = 'IProductFavoratable';
    }

}
